module.exports = __webpack_public_path__ + "components/country-flag/static/pa-7a6f9bc745fafca3bcd7ba8925cfe28a.svg";